import { createClient } from '@supabase/supabase-js';

const chatSupabaseUrl = import.meta.env?.VITE_CHAT_SUPABASE_URL;
const chatSupabaseAnonKey = import.meta.env?.VITE_CHAT_SUPABASE_ANON_KEY;

if (!chatSupabaseUrl || !chatSupabaseAnonKey) {
  console.warn('Chat Supabase credentials not configured. Set VITE_CHAT_SUPABASE_URL and VITE_CHAT_SUPABASE_ANON_KEY in your .env file.');
}

export const chatSupabase = chatSupabaseUrl && chatSupabaseAnonKey
  ? createClient(chatSupabaseUrl, chatSupabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        storageKey: 'chat_supabase_auth',
      },
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    })
  : null;
